angular.module('dnecom')
    .controller('StoreHomePageSettingsController', ["$scope", "StoreUtils", "MediaUtils", function ($scope, StoreUtils, MediaUtils) {
        $scope.urlUploadBtnText = 'Upload from url';

        $scope.urlUploading = false;

        var ogImageMarkedForDelete = false;

        $scope.isOGImageMarkedForDelete = function () {
            return ogImageMarkedForDelete;
        };

        $scope.cancelOGImageDeletion = function () {
            ogImageMarkedForDelete = false;
        };

        $scope.markOGImageForDelete = function () {
            ogImageMarkedForDelete = true;
        };

        $scope.save = function (form) {
            // copy value and restore on fail
            var currentOGImage = $scope.store.ogImage;

            if (ogImageMarkedForDelete) {
                $scope.store.ogImage = {};
            }

            if (!$scope.$parent.save(form)) {
                $scope.store.ogImage = currentOGImage;

                return false;
            }

            if (ogImageMarkedForDelete && currentOGImage.id) {
                MediaUtils.scheduleDelete(currentOGImage.id);
            }

            MediaUtils.processDelete();

            $scope.cancelOGImageDeletion();

            return true;
        };

        $scope.reset = function () {
            if ($scope.store.ogImage) {
                MediaUtils.scheduleDelete($scope.store.ogImage.id);
            }

            $scope.cancelOGImageDeletion();
            $scope.$parent.reset();

            if ($scope.store.ogImage) {
                MediaUtils.cancelDelete($scope.store.ogImage.id);
            }

            MediaUtils.processDelete();
        };

        $scope.storeChanged = function () {
            return $scope.$parent.storeChanged() || $scope.isOGImageMarkedForDelete();
        };

        $scope.upload = function (file) {
            StoreUtils.upload($scope.store, file, function (media) {
                if ($scope.store.ogImage) {
                    MediaUtils.scheduleDelete($scope.store.ogImage.id);
                }
                $scope.store.ogImage = media;
                $scope.cancelOGImageDeletion();
            });
        };

        $scope.uploadUrl = function (url) {
            if (url && url.length > 0) {
                $scope.urlUploadBtnText = 'Uploading...';
                $scope.urlUploading = true;

                StoreUtils.uploadUrl($scope.store, url, function (media) {
                    if ($scope.store.ogImage) {
                        MediaUtils.scheduleDelete($scope.store.ogImage.id);
                    }
                    $scope.store.ogImage = media;
                    $scope.cancelOGImageDeletion();
                    $scope.urlUploadBtnText = 'Upload from url';
                    $scope.urlUploading = false;
                    $scope.og_image_url = '';
                });
            }
        };
    }]);
